module.exports = "<div class=\"lmsPane\">\r\n\r\n</div>\r\n";